import { cn } from "@newxsystems/shared";
import { DaylightCommonContent } from "../../../../modules/content/components/DaylightCommonContent/DaylightCommonContent";
import { DaylightRichText } from "../../../../modules/content/components/DaylightRichText/DaylightRichText";
import { DaylightSection } from "../../../../modules/content/components/DaylightSection/DaylightSection";
import type { IWysiwygBlockProps } from "./WysiwygBlock.props";

const proseClass =
  "text-lg text-northsea [&_a]:text-primary [&_a]:underline [&_a]:underline-offset-4 [&_blockquote]:my-10 [&_blockquote]:border-l-2 [&_blockquote]:border-primary [&_blockquote]:pl-6 [&_blockquote]:font-daylight-display [&_blockquote]:text-2xl [&_blockquote]:leading-tight [&_blockquote]:text-graphite [&_h2]:mt-14 [&_h2]:font-daylight-display [&_h2]:text-4xl [&_h2]:font-bold [&_h2]:tracking-[-0.04em] [&_h2]:text-graphite [&_h2:first-child]:mt-0 [&_h3]:mt-10 [&_h3]:font-daylight-display [&_h3]:text-2xl [&_h3]:font-semibold [&_h3]:tracking-[-0.02em] [&_h3]:text-graphite [&_hr]:my-12 [&_hr]:border-border [&_li]:my-2 [&_ol]:list-decimal [&_ol]:pl-6 [&_p+p]:mt-6 [&_strong]:font-medium [&_strong]:text-graphite [&_ul]:list-disc [&_ul]:pl-6";

export const WysiwygBlock = ({
  alignment,
  anchorId,
  buttons,
  content,
  description,
  eyebrow,
  heading,
  parentClass,
  spacing,
}: IWysiwygBlockProps) => {
  if (!content) return null;
  const hasIntro = Boolean(eyebrow || heading || description || buttons?.length);

  return (
    <DaylightSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-12 md:gap-16">
        {hasIntro ? (
          <DaylightCommonContent
            alignment={alignment}
            buttons={buttons}
            description={description}
            eyebrow={eyebrow}
            heading={heading}
            layout="rail"
          />
        ) : null}
        <div className="grid grid-cols-12">
          <DaylightRichText
            className={cn(
              "col-span-12 max-w-[68ch]",
              hasIntro && "md:col-span-8 md:col-start-5",
              proseClass,
            )}
            content={content}
          />
        </div>
      </div>
    </DaylightSection>
  );
};

WysiwygBlock.displayName = "Block::WysiwygBlock";
